import { Action, Selector, State, StateContext } from '@ngxs/store';
import { Injectable } from '@angular/core';
import { UserPrivilegeEnum } from '../../../../enums/rights/user-privilege.enum';
import { RInvoice } from './r-invoice.action';
import { ResetStateDefaults } from '../../../base-action-class.model';

interface RInvoiceXsStateModel{
  viewInvoice: string;
  createInvoice: string;
  editInvoice: string;
  deleteInvoice: string;
  viewAllInvoices: string;
  manageAllInvoices: string;
}

const getDefaults = (): RInvoiceXsStateModel => ({
  viewInvoice: null,
  createInvoice: null,
  editInvoice: null,
  deleteInvoice: null,
  viewAllInvoices: null,
  manageAllInvoices: null,
});

@State<RInvoiceXsStateModel>({
  name: 'rInvoice',
  defaults: getDefaults()
})
@Injectable()
export class RInvoiceXsState {

  //region SELECTOR
  @Selector()
  static canViewInvoice(state: RInvoiceXsStateModel): boolean {
    return state.viewInvoice != null;
  }

  @Selector()
  static canCreateInvoice(state: RInvoiceXsStateModel): boolean {
    return state.createInvoice != null;
  }

  @Selector()
  static canEditInvoice(state: RInvoiceXsStateModel): boolean {
    return state.editInvoice != null;
  }

  @Selector()
  static canDeleteInvoice(state: RInvoiceXsStateModel): boolean {
    return state.deleteInvoice != null;
  }

  @Selector()
  static canViewAllInvoices(state: RInvoiceXsStateModel): boolean {
    return state.viewAllInvoices != null;
  }

  @Selector()
  static canManageAllInvoices(state: RInvoiceXsStateModel): boolean {
    return state.manageAllInvoices != null;
  }
  //endregion

  //region ACTIONS
  @Action(RInvoice.SetInvoicePrivileges)
  public setImportPrivileges(ctx: StateContext<RInvoiceXsStateModel>, action: RInvoice.SetInvoicePrivileges) {
    const importPrivileges = [...action.activeUserRightInfoDtoModel.invoicePrivileges];

    //find user privilege data model
    const viewInvoice =
      importPrivileges.find(id => id === UserPrivilegeEnum.VIEW_INVOICE);
    const createInvoice
      = importPrivileges.find(id => id === UserPrivilegeEnum.CREATE_INVOICE);
    const editInvoice
      = importPrivileges.find(id => id === UserPrivilegeEnum.EDIT_INVOICE);
    const deleteInvoice
      = importPrivileges.find(id => id === UserPrivilegeEnum.DELETE_INVOICE);
    const viewAllInvoices
      = importPrivileges.find(id => id === UserPrivilegeEnum.VIEW_ALL_INVOICES);
    const manageAllInvoices
      = importPrivileges.find(id => id === UserPrivilegeEnum.MANAGE_ALL_INVOICES);

    //set the state
    ctx.patchState({
      viewInvoice,
      createInvoice,
      editInvoice,
      deleteInvoice,
      viewAllInvoices,
      manageAllInvoices,
    });
  }

  @Action(ResetStateDefaults)
  public resetDefaults(ctx: StateContext<RInvoiceXsStateModel>): void {
    ctx.setState({...getDefaults()});
  }
  //endregion
}
